import { Component, OnInit } from '@angular/core';
import { FieldConfig } from 'src/app/core/interfaces/field-config';
import { BroadcastService } from 'src/app/shared/services/broadcast.service';
import { DynamicFormServiceService } from 'src/app/shared/services/dynamic-form-service.service';
import {
  UntypedFormGroup,
  UntypedFormArray
} from '@angular/forms';
import { Option } from 'src/app/core/interfaces/options-dynamicform';

@Component({
    selector: 'app-checkbox-form',
    templateUrl: './checkbox-form.component.html',
    styleUrls: ['./checkbox-form.component.scss'],
    standalone: false
})
export class CheckboxFormComponent implements OnInit {

  field: FieldConfig;
  group: UntypedFormGroup;
  isRequired: boolean;
  toggleCheck: boolean;
  currentControlName: any;
  sortedOptions: Option[];
  constructor(
    private broadCastService: BroadcastService,
    private dynamicService: DynamicFormServiceService) {}

  ngOnInit() {
    this.sortedOptions = this.sortedSequence();
    this.isRequired = this.dynamicService.checkHasRequired(this.field);
    if (this.isRequired) { this.getFromArray.setValidators(this.checkboxAtLeastOneSelected); }
   
  }

  get getFromArray(): UntypedFormArray {
    return this.group.get(this.field.labelCode) as UntypedFormArray;
  }

  setCheckBoxValue(event, value: Option, controlName) {
    const labelCodeExist = this.dynamicService.revealChildLabelCodes(this.field.childAoeDtos, value.code, this.field.labelCode);
    if (event.checked) {
      if (labelCodeExist !== -1) {
        this.broadCastService.broadcast('SHOW_OPTIONS', labelCodeExist);
      }
    } else {
      const childAllLabelCodes = this.dynamicService.getAllChildAOEcodeFomParent(this.field);
      const skipHide = this.checkWhetherParentisChecked();
      if (childAllLabelCodes.length > 0 && !skipHide) { this.broadCastService.broadcast('CLEAR_OPTIONS', childAllLabelCodes); }
      this.getFromArray.at(controlName).setValue(null);
    }
  }

  private sortedSequence() {
    if (this.field && this.field.options) {
      return ((this.field.labelCode === 'SONOID' ||
        this.field.labelCode === 'SSUPER') ?
        this.field.options.sort((a, b) => {
          const left = a.value.toUpperCase();
          const right = b.value.toUpperCase();
          if (left < right) {
            return -1;
          }
          if (left > right) {
            return 1;
          }
          return 0;
        }) : this.field.options.sort((a, b) => a.sequence - b.sequence));
      }
  }

  private checkWhetherParentisChecked() {
    const checkedOptionsCode = this.sortedOptions.filter((x) => x.isSelected).map((x) => x.code);
    let dontHideChild: boolean;
    if (this.field.childAoeDtos.length > 0) {
      dontHideChild = this.field.childAoeDtos.some((x) => {
        return (checkedOptionsCode.indexOf(x.enumOptionCode) > -1);
      });
    }
    return dontHideChild;
  }

  private checkboxAtLeastOneSelected(form: UntypedFormGroup) {
    return Object.keys(form.controls)
            .some(control => form.controls[control].value === true) ? null : { invalidCheckboxes: true };
  }
}
